"use strict"
exports.__esModule = true;
exports.SwatchbookIconConfig = {
  name: 'SwatchbookIcon',
  height: 512,
  width: 512,
  svgPath: 'M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z',
  yOffset: 0,
  xOffset: 0,
};
exports.SwatchbookIcon = require('../createIcon').createIcon(exports.SwatchbookIconConfig);
exports["default"] = exports.SwatchbookIcon;